module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-bottom-818b962441d7e97a2f522ce76bb44673.svg";